// extracted by mini-css-extract-plugin
export default {"wrapper":"SharingCandidate_wrapper__GKs3e"};